import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=653e467a&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=653e467a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653e467a",
  null
  
)

export default component.exports